import { AfterContentInit, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import {
    ClassNames,
    IRadioOption,
    RadioOption,
    BaseFormControlComponent
} from '@lsq-frontend/common-ui';

enum AccountRelationshipType {
    GenerateAccount,
    ExistingAccount,
    NewAccount
}

@Component({
    selector: 'create-buyer-account-relationship-radio-list',
    template: `
        <ul class="list-unstyled">
            <li [style.margin-bottom]="'2.4rem'">
                <lsq-radio
                    [id]="options[0].id"
                    [label]="options[0].label"
                    [value]="options[0].value"
                    [name]="name"
                    [ngModel]="model"
                    (ngModelChange)="handleChange($event)"
                    [disabled]="disabled"
                >
                </lsq-radio>
            </li>

            <li [style.margin-bottom]="'2.4rem'">
                <lsq-radio
                    [id]="options[1].id"
                    [label]="options[1].label"
                    [value]="options[1].value"
                    [name]="name"
                    [ngModel]="model"
                    (ngModelChange)="handleChange($event)"
                    [disabled]="disabled"
                >
                </lsq-radio>
            </li>
            <ng-content select="[account-search]"></ng-content>

            <li [style.margin-bottom]="'2.4rem'">
                <lsq-radio
                    [id]="options[2].id"
                    [label]="options[2].label"
                    [value]="options[2].value"
                    [name]="name"
                    [ngModel]="model"
                    (ngModelChange)="handleChange($event)"
                    [disabled]="disabled"
                >
                </lsq-radio>
            </li>
            <ng-content select="[new-account]"></ng-content>
        </ul>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CreateBuyerAccountRelationshipRadioList),
            multi: true
        }
    ]
})
export class CreateBuyerAccountRelationshipRadioList extends BaseFormControlComponent<any>
    implements AfterContentInit {
    public name = 'accountRelationshipType';
    public options: IRadioOption[] = [
        {
            id: 'nonBusinessUnits',
            label:
                'Automatically create an Account for this Buyer. (Use this for a Buyer that is not part of a Business Units Account)',
            value: AccountRelationshipType.GenerateAccount
        },
        {
            id: 'existingBusinessUnits',
            label: 'Relate this Buyer to an existing Account.',
            value: AccountRelationshipType.ExistingAccount
        },
        {
            id: 'newBusinessUnits',
            label:
                'Create a new Account. (Use this if this is the first Buyer of a Business Units Account)',
            value: AccountRelationshipType.NewAccount
        }
    ];

    public ngAfterContentInit(): void {
        this.buildOptions();
    }

    public getClassList(): string {
        const listClass = ClassNames.ListUnstyled;
        return `${listClass}`;
    }

    public buildOptions(): void {
        if (this.options.length > 0) {
            this.options = [...this.options].map((option, index) => {
                const radioOption = new RadioOption();

                if (option && typeof option !== 'object') {
                    radioOption.label = `${option}`;
                    radioOption.value = option;
                    radioOption.id = `${this.name}-${typeof option}-${index}`;
                } else {
                    return option;
                }

                radioOption.checked = this.model && this.model === option;
                return radioOption;
            });
        }
    }
}
